import React from "react";
import CodeEditor from "../components/CodeEditor";
const baseurl = "rizzapi.vercel.app/";

const GetByLanguage = () => {
  return (
    <section id="language">
      <div className="dbline"></div>
      <div className="endpoint">2.Language</div>
      <div className="idea">
        ⚠️ Language possesses the unique ability to bridge hearts across
        borders. We're working on adding pickup lines in more languages, but as
        a solo developer and student, it may take some time. Thank you for your
        patience and support as we strive to make our platform more inclusive.
        Stay tuned for updates! 😄🌍
      </div>
      Languages :
      <ul className="disc">
        <li>english</li>
        <li>spanish</li>
        <li>french</li>
        <li>german</li>
        <li>italian</li>
      </ul>
      <div className="line"></div>
      Method: <span className="method">GET</span>
      <div className="dbline"></div>
      URL: <span className="method">{baseurl}language/:Language</span>
      <div className="dbline"></div>
      Query Parameters
      <ul>
        <li>
          <span className="method">page </span>
          <div className="idea">
            (optional, default: 1) - The page number of results to retrieve.
          </div>
        </li>
        <li>
          <span className="method">perPage</span>
          <div className="idea">
            (optional, default: 20) - The number of responses to return per
            page.
          </div>
        </li>
      </ul>
      <br />
      <div className="line"></div>
      Example Request
      <CodeEditor>{`rizzapi.vercel.app/language/:English?page=1&perPage=1`}</CodeEditor>
      <br />
      Response:
      <br />
      <CodeEditor>{`[
  {
    "ratings": {
      "average": 0,
      "count": 0
    },
    "_id": "65147a8b63ef48d364f9fca2",
    "text": "I’m learning about important dates in history. Wanna be one of them?",
    "category": "Funny",
    "language": "English",
    "tags": [],
    "usageExamples": [],
    "dateCreated": "2023-09-27T18:55:07.262Z",
    "comments": [],
    "__v": 0
  }
]

`}</CodeEditor>
      <div className="line"></div>
    </section>
  );
};

export default GetByLanguage;
